export default __webpack_public_path__ + "static/media/轮播首图10.2d191beb.jpg";